import moment from "moment";
import styled from "styled-components";

type MonthYearSelectorProps = {
  month: moment.Moment;
  onMonthSelect: (currentMonth: moment.Moment, newMonthVal: string) => void;
  onYearSelect: (currentMonth: moment.Moment, newMonthVal: string) => void;
};

const Container = styled.div`
  display: flex;
  justify-content: center;

  select + select {
    margin-left: 8px;
  }
`;

const StyledSelect = styled.select`
  border-radius: 5px;
  padding: 6px;
  background-color: transparent;
  border: 1px solid var(--color-primary-400);
  color: var(--color-primary-400);
  font-family: var(--font-family-alpha);
  font-size: var(--size-font-small);
  cursor: pointer;
`;

export const MonthYearSelector = ({
  month,
  onMonthSelect,
  onYearSelect,
}: MonthYearSelectorProps) => {
  const YEAR_PADDING = 10;

  const renderYearOptions = () => {
    const year = moment().year();
    const minYear = year - YEAR_PADDING;
    const maxYear = year + YEAR_PADDING;

    const options = [];
    for (let i = minYear; i <= maxYear; i++) {
      options.push(
        <option key={i} value={i}>
          {i}
        </option>
      );
    }
    return options;
  };

  return (
    <Container>
      <StyledSelect
        value={month.month()}
        onChange={(e) => onMonthSelect(month, e.target.value)}
      >
        {moment.months().map((label, value) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </StyledSelect>
      <StyledSelect
        value={month.year()}
        onChange={(e) => onYearSelect(month, e.target.value)}
      >
        {renderYearOptions()}
      </StyledSelect>
    </Container>
  );
};
